import React from 'react';

type AppleIconProps = {
  size?: number;
  color?: string;
};

export const AppleIcon: React.FC<AppleIconProps> = ({ size = 28, color = 'currentColor' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d="M17.564 13.862c-.03-3.2 2.61-4.745 2.73-4.82-1.49-2.18-3.81-2.48-4.63-2.515-1.97-.2-3.85 1.16-4.85 1.16-1 0-2.55-1.13-4.2-1.1-2.16.03-4.15 1.26-5.26 3.2-2.25 3.9-.58 9.68 1.61 12.84 1.07 1.55 2.35 3.29 4.03 3.23 1.62-.06 2.23-1.05 4.19-1.05 1.96 0 2.52 1.05 4.23 1.02 1.74-.03 2.84-1.58 3.9-3.14 1.23-1.8 1.74-3.55 1.77-3.64-.04-.02-3.39-1.3-3.42-5.18z" />
      <path d="M14.89 3.46c.88-1.06 1.47-2.54 1.31-4-1.27.05-2.81.85-3.72 1.9-.82.94-1.54 2.45-1.35 3.89 1.42.11 2.88-.72 3.76-1.79z" />
    </svg>
  );
};

